import { render } from "./companies-crm.vue?vue&type=template&id=108b2e3f"
import script from "./companies-crm.vue?vue&type=script&lang=js"
export * from "./companies-crm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__